'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import LogRocket from 'logrocket';
import { getEnv } from '@/utils/env';
export function LogRocketInit() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  const key = getEnv("LOGROCKET_KEY");
  if (key) {
    LogRocket.init(key);
  }
}